'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _getCurrentView = require('./selectors/getCurrentView');

var _CurrentView = require('./CurrentView');

var _CurrentView2 = _interopRequireDefault(_CurrentView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentView: (0, _getCurrentView.getCurrentView)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_CurrentView2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/current-view/CurrentViewContainer.js
// module id = 958
// module chunks = 2 3